/* tslint:disable */
/* eslint-disable */
export enum KreditvaerdigEnumDto {
  NotSet = 'NotSet',
  Yes = 'Yes',
  Maybe = 'Maybe',
  No = 'No'
}
